<template>
  <div>
    <!-- Not authenticated -->
    <div v-if="state.isAuthenticated === false">
      <login />
    </div>

    <div v-else>
      <Navbar />
      <div v-if="isLoading"></div>

      <!-- Authorized with specific role OR in development mode -->
      <div v-else-if="(decodedToken?.roles || []).includes('ReadJobs') || isDevelopment">
        <div class="content">
          <RouterView />
          <Notification/>
        </div>
      </div>

      <!-- Authorized but without required role -->
      <div v-else-if="decodedToken?.roles">
        <div class="access-denied">
          <h1>Access denied</h1>
          <p>You don't have the required permissions to access this page. If this is a mistake,
            or you need access, please contact an AD administrator to be granted the necessary
            permissions.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue'
import { RouterView } from 'vue-router'
import Navbar from '@/components/NavBar/NavBar.vue'
import { msalService } from './config/useAuth.js'
import { msalInstance, state } from './config/msalConfig.js'
import Login from "./components/loginSide.vue"
import Notification from './components/Notification.vue'

const { login, handleRedirect, registerAuthorizationHeaderInterceptor } = msalService()

// Reactive state for decodedToken
const decodedToken = ref({ roles: [] })
const isLoading = ref(false)
const isDevelopment = ref(window.location.hostname === 'localhost')

const initialize = async () => {
  try {
    await msalInstance.initialize()
    registerAuthorizationHeaderInterceptor()
  } catch (error) {
    console.error('Initialization error', error)
  }
}

onMounted(async () => {
  isLoading.value = true // Start in a loading state
  await initialize()
  decodedToken.value = await handleRedirect()
  isLoading.value = false // Set loading to false once handling is complete
})
</script>

<style scoped>
.content {
  padding: 5rem 5rem;
}

.access-denied {
  width: 500px;
}

main {
  margin: auto;
}
</style>